// extracted by mini-css-extract-plugin
module.exports = {"spinnerCircle":"spinner-module--spinnerCircle--3LI85","ldsRing":"spinner-module--ldsRing--1mwYp"};